const slickSlider = () => {

  const $sliderTop = $('.js-slick-slider-top');

  function preloadSlide($slider, currentSlide, amount) {
    const $imagePrevObj = $slider.find(`div[data-slick-index="${currentSlide - amount}"]`).find('.slide-image');
    const $imageNextObj = $slider.find(`div[data-slick-index="${currentSlide + amount}"]`).find('.slide-image');
    const imagePrevSrc = $imagePrevObj.data('lazy');
    const imageNextSrc = $imageNextObj.data('lazy');

    if (imagePrevSrc !== $imagePrevObj.attr('src')) {
      $imagePrevObj.attr('src', imagePrevSrc);
    }
    if (imageNextSrc !== $imageNextObj.attr('src')) {
      $imageNextObj.attr('src', imageNextSrc);
    }
  }

  $sliderTop.slick({
    centerMode: true,
    centerPadding: '0',
    cssEase: 'linear',
    fade: true,
    dots: true,
    autoplay: true,
    autoplaySpeed: 7000,
    pauseOnFocus: false,
    pauseOnHover: false,
    speed: 500,
    lazyLoad: 'ondemand',
    prevArrow: $('.js-prev-slide-in-slider-top'),
    nextArrow: $('.js-next-slide-in-slider-top')
  });

  $sliderTop.on('beforeChange', (event, slick, currentSlide) => {
    preloadSlide($sliderTop, currentSlide, 2);
    if (window.innerWidth >= 768) {
      preloadSlide($sliderTop, currentSlide, 3);
    }
  });

  $sliderTop.on('afterChange', (event, slick, currentSlide) => {
    preloadSlide($sliderTop, currentSlide, 1);
    if (window.innerWidth >= 768) {
      preloadSlide($sliderTop, currentSlide, 2);
    }
  });
};

module.exports = slickSlider;
